import Lawrence from "../Assets/Lawrence.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={Lawrence}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Lawrence Wee</h2>
        <p className="card-sub-name-style">
          Director, Business & Ecosystems, <br /> BizTech Group, IMDA
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Lawrence Wee</h2>
            <h3>Director, Business & Ecosystems, BizTech Group, IMDA</h3>

            <br />
            <p>
              Dr. Lawrence Wee is currently Director of the Business and
              Ecosystems division at IMDA. His team is responsible for driving
              strategic collaborations to catalyze the exploitation and adoption
              of AI and emerging technologies for enterprises.
              <br />
              <br />
              He started his career in public sector research and development
              when he founded the Healthcare and Biomedical Analytics Laboratory
              at the Institute of Infocomm Research (I2R), which focused on
              building deep capabilities in machine learning for biomedicine and
              healthcare. After the stint at I2R, he moved on to Zuellig Pharma
              where he took on the role of Chief Data Scientist and led the
              development of institutional data science capabilities across APAC
              region. Following that, he joined Allianz Asia-Pacific, where he
              was responsible for building the regional APAC healthcare data
              science capabilities across life and health insurance business
              units. Thereafter, he returned to public service at the Ministry
              of Health where he had the opportunity to drive strategy and
              capability development in AI and emerging technologies for the
              public health sector.
              <br />
              <br />
              He is an Associate Faculty at the Singapore University of Social
              Sciences, and was previously the President of the Association for
              Medical and Bio-informatics Singapore (AMBIS), and vice-chair of
              the Chinese-American Pharmaceutical Society (CABS) Singapore
              chapter.
              <br />
              <br />
              He received his Ph.D. in Computational Biology from the National
              University of Singapore.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
